var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "film 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M34.5 34H24.1C30.44 31.7 35 25.63 35 18.5C35 9.4 27.6 2 18.5 2C9.4 2 2 9.4 2 18.5C2 27.6 9.4 35 18.5 35H34.5C34.78 35 35 34.78 35 34.5C35 34.22 34.78 34 34.5 34ZM3 18.5C3 9.95 9.95 3 18.5 3C27.05 3 34 9.95 34 18.5C34 27.05 27.05 34 18.5 34C9.95 34 3 27.05 3 18.5ZM18.5 14C20.43 14 22 12.43 22 10.5C22 8.57 20.43 7 18.5 7C16.57 7 15 8.57 15 10.5C15 12.43 16.57 14 18.5 14ZM18.5 8C19.88 8 21 9.12 21 10.5C21 11.88 19.88 13 18.5 13C17.12 13 16 11.88 16 10.5C16 9.12 17.12 8 18.5 8ZM22 26.5C22 24.57 20.43 23 18.5 23C16.57 23 15 24.57 15 26.5C15 28.43 16.57 30 18.5 30C20.43 30 22 28.43 22 26.5ZM16 26.5C16 25.12 17.12 24 18.5 24C19.88 24 21 25.12 21 26.5C21 27.88 19.88 29 18.5 29C17.12 29 16 27.88 16 26.5ZM26.5 22C28.43 22 30 20.43 30 18.5C30 16.57 28.43 15 26.5 15C24.57 15 23 16.57 23 18.5C23 20.43 24.57 22 26.5 22ZM26.5 16C27.88 16 29 17.12 29 18.5C29 19.88 27.88 21 26.5 21C25.12 21 24 19.88 24 18.5C24 17.12 25.12 16 26.5 16ZM10.5 15C8.57 15 7 16.57 7 18.5C7 20.43 8.57 22 10.5 22C12.43 22 14 20.43 14 18.5C14 16.57 12.43 15 10.5 15ZM10.5 21C9.12 21 8 19.88 8 18.5C8 17.12 9.12 16 10.5 16C11.88 16 13 17.12 13 18.5C13 19.88 11.88 21 10.5 21Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilm);
export default __webpack_public_path__ + "static/media/film.e532b0426c03e70d468a7af99b7492bd.svg";
export { ForwardRef as ReactComponent };